export const setPrintaction = ({ name, target, value }: any) => ({
  type: "SET_PRINT_ACTIONS",
  payload: { name, target, value },
});
export const setPrintclinic = (e: any) => ({
  type: "SET_PRINT_CLINIC",
  payload: e,
});
export const setPrintPatient = (e: any) => ({
  type: "SET_PRINT_PATIENT",
  payload: e,
});
export const setPrintAmount = (e: any) => ({
  type: "SET_PRINT_AMOUNT",
  payload: e,
});
export const setPrintTreatment = (e: any) => ({
  type: "SET_PRINT_TREATMENT",
  payload: e,
});
export const setPrintSubTreatment = (e: any) => ({
  type: "SET_PRINT_SUB_TREATMENT",
  payload: e,
});


// 
export const setPresPrintaction = ({ name, target, value }: any) => ({
  type: "SET_PRESCRIPTIONPRINT_ACTIONS",
  payload: { name, target, value },
});
export const setPresPrintclinic = (e: any) => ({
  type: "SET_PRESCRIPTIONPRINT_CLINIC",
  payload: e,
});
export const setPresPrintPatient = (e: any) => ({
  type: "SET_PRESCRIPTIONPRINT_PATIENT",
  payload: e,
});
export const setPresPrintAmount = (e: any) => ({
  type: "SET_PRESCRIPTIONPRINT_AMOUNT",
  payload: e,
});
export const setPresPrintTreatment = (e: any) => ({
  type: "SET_PRESCRIPTIONPRINT_TREATMENT",
  payload: e,
});

export const setPrintTemplate2action = ({ name, target, value }: any) => ({
  type: "SET_PRINTTEMPLATE2_ACTIONS",
  payload: { name, target, value },
});
export const setPrintTemplate2clinic = (e: any) => ({
  type: "SET_PRINTTEMPLATE2_CLINIC",
  payload: e,
});
export const setPrintTemplate2Patient = (e: any) => ({
  type: "SET_PRINTTEMPLATE2_PATIENT",
  payload: e,
});
export const setPrintTemplate2Amount = (e: any) => ({
  type: "SET_PRINTTEMPLATE2_AMOUNT",
  payload: e,
});
export const setPrintTemplate2Treatment = (e: any) => ({
  type: "SET_PRINTTEMPLATE2_TREATMENT",
  payload: e,
});
export const setPrintTemplate2SubTreatment = (e: any) => ({
  type: "SET_PRINTTEMPLATE2_SUB_TREATMENT",
  payload: e,
});

export const setTokenPrintaction = ({ name, target, value }: any) => ({
  type: "SET_TOKENPRINT_ACTIONS",
  payload: { name, target, value },
});
export const setTokenPrintclinic = (e: any) => ({
  type: "SET_TOKENPRINT_CLINIC",
  payload: e,
});
export const setTokenPrintToken = (e: any) => ({
  type: "SET_TOKENPRINT_TOKEN",
  payload: e,
});
